// extracted by mini-css-extract-plugin
export var container = "footer-module--container--HXu2X";